import { render, staticRenderFns } from "./CoverageMap.vue?vue&type=template&id=3980da1f&scoped=true&"
import script from "./CoverageMap.vue?vue&type=script&lang=js&"
export * from "./CoverageMap.vue?vue&type=script&lang=js&"
import style0 from "./CoverageMap.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CoverageMap.vue?vue&type=style&index=1&id=3980da1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980da1f",
  null
  
)

export default component.exports